// extracted by mini-css-extract-plugin
export default {"stepIcon":"step_stepIcon__KnHw7","stepIconActive":"step_stepIconActive__XtYTx"};